import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { appInsightsLoggerPlugin } from '@shared/utils/appInsightsLogger';
import { router } from './app.routing';
import 'vue-advanced-cropper/dist/style.css';
import AppView from './AppViewComponent.vue';
import Navbar from './patterns/Navbar.vue';
import { attachAxiosInterceptor } from './plugins/axios';
import d2kit from './plugins/d2kit';
const vueApp = createApp({});
attachAxiosInterceptor(vueApp);
vueApp.use(d2kit);
vueApp.use(appInsightsLoggerPlugin, {
    instrumentationKey: window.appInsightsConfig,
});
vueApp.use(router);
vueApp.use(createPinia());
vueApp.component('Navbar', Navbar);
vueApp.component('AppView', AppView);
const elem = document.getElementById('loadCover');
elem.parentNode.removeChild(elem);
vueApp.mount('#vue-wrapper');
